<template>
  <div ref="kpiInfoSummary" class="kpi-info-summary">
    <h6 class="text-muted text-uppercase">
      <div class="row">
        <div class="col-xs-4 title">{{ 'dictionary.media.insertion.kpi.by.' + pType.toLocaleLowerCase() | i18nText(pDictionary) }}</div>
        <div class="col-xs-4"></div>
        <div class="col-xs-4 text-right">
          <span  v-if="!loading" data-toggle="tooltip" :data-original-title="'dictionary.media.insertion.kpi.by.' + pType.toLocaleLowerCase() + '.analysis.level.' + kpiInfo.analysis.quantityPacingAnalysisLevel | i18nText(pDictionary) | i18nparams(0, i18nKpiName)">
            <metric-kpi-info-pacing-analysis
                :p-dictionary="pDictionary"
                :p-analysis-level="kpiInfo.analysis.quantityPacingAnalysisLevel">
            </metric-kpi-info-pacing-analysis>
          </span>
        </div>
      </div>
    </h6>
    <div class="well well-sm">
      <div v-if="loading" class="text-center text-muted">
        <i class="fa-light fa-3x fa-spinner fa-pulse fa-fw"></i>
      </div>
      <div v-else class="row">
        <div class="col-xs-4 text-left cost-for">
          <small class="text-muted text-uppercase text-nowrap d-block-ellipsis title"
                 :title="pDictionary['dictionary.media.insertion.kpi.' + kpiInfo.name + '.cost-for']">
            {{ 'dictionary.media.insertion.kpi.' + kpiInfo.name + '.cost-for' | i18nText(pDictionary) }}
          </small>
          <h4 class="bs3-margin-top5 bs3-margin-bottom-reset actual">
            {{ kpiInfo.actual.costFor | money(pCurrencies, kpiInfo.currencyId) | emptyToDash }}
          </h4>
          <h4 class="bs3-margin-top5 bs3-margin-bottom-reset planned">
            <small>{{ kpiInfo.planned.costFor | money(pCurrencies, kpiInfo.currencyId) | emptyToDash }}</small>
          </h4>
        </div>
        <div class="col-xs-4 text-center quantity">
          <small class="text-muted text-uppercase d-block-ellipsis title"
            :title="pDictionary['dictionary.media.insertion.kpi.' + kpiInfo.name + '.nb']">
            {{ 'dictionary.media.insertion.kpi.' + kpiInfo.name + '.nb' | i18nText(pDictionary) }}
          </small>
          <h4 class="bs3-margin-top5 bs3-margin-bottom-reset actual">
            {{ kpiInfo.actual.quantity | emptyToDash }}
          </h4>
          <h4 class="bs3-margin-top5 bs3-margin-bottom-reset planned">
            <small>{{ kpiInfo.planned.quantity | emptyToDash }}</small>
          </h4>
        </div>
        <div class="col-xs-4 text-right cost-per">
          <small class="text-muted text-uppercase d-block-ellipsis title"
            :title="pDictionary['dictionary.media.insertion.kpi.' + kpiInfo.name + '.cost-per']">
            {{ 'dictionary.media.insertion.kpi.' + kpiInfo.name + '.cost-per'| i18nText(pDictionary) }}
          </small>
          <h4 class="bs3-margin-top5 bs3-margin-bottom-reset actual">
            {{ kpiInfo.actual.costPer | money(pCurrencies, kpiInfo.currencyId) | emptyToDash }}
          </h4>
          <h4 class="bs3-margin-top5 bs3-margin-bottom-reset planned">
            <small>{{ kpiInfo.planned.costPer | money(pCurrencies, kpiInfo.currencyId) | emptyToDash }}</small>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormatMixin from "@/mixins/format-mixin";
import MetricKpiInfoPacingAnalysis from "@/components/common/metric/kpi/info/MetricKpiInfoPacingAnalysis";

export default {
  name: "MetricKpiInfoSummary",
  components: {MetricKpiInfoPacingAnalysis},
  mixins: [FormatMixin],
  props: {
    pDictionary: {
      type: Object,
      required: true
    },
    pCurrencies: Array,
    pType: {
      type: String,
      required: true
    },
    pKpiName: {
      type: String,
      required: true
    },
    pDataListInput: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      loading: true,
      kpiInfo: null
    }
  },
  methods: {
    refreshKpiInfoPeriod()
    {
      let _component = this;
      _component.loading = true;
      _component.kpiInfoPeriod = null;
      $.ajax({
               type: "POST",
               url: "/mediaplan/app/endpoints/json-api/metrics/kpis/" + _component.pKpiName.toUpperCase(),
               data: JSON.stringify(_component.pDataListInput),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (data) {
        _component.kpiInfo = data;
        _component.loading = false;
      });
    }
  },
  computed: {
    i18nKpiName: function() {
      return this.pDictionary['dictionary.media.insertion.kpi.' + this.pKpiName.toLowerCase()];
    }
  },
  watch: {
    pDataListInput: function () {
      this.refreshKpiInfoPeriod();
    }
  },
  mounted: function () {
    const _component = this;
    _component.refreshKpiInfoPeriod();
    _component.$nextTick(function () {
      const $kpiInfoSummary = $(_component.$refs.kpiInfoSummary);
      $kpiInfoSummary.find('[data-toggle="tooltip"]').tooltip({container: 'body', sanitize: false});
    });
  },
  updated: function () {
    const _component = this;
    _component.$nextTick(function () {
      const $kpiInfoSummary = $(_component.$refs.kpiInfoSummary);
      $kpiInfoSummary.find('[data-toggle="tooltip"]').tooltip({container: 'body', sanitize: false});
    });
  },
  destroy: function () {
    const _component = this;
    const $kpiInfoSummary = $(_component.$refs.kpiInfoSummary);
    $kpiInfoSummary.find('[data-toggle="tooltip"]').tooltip('destroy');
  }
}
</script>

<style scoped>

</style>